import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function initScroll() {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
      }, 0);
    };
    scrollToTop();
  }, [pathname]);

  return null;
}

export default initScroll;
